module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.param.readonly) ? _c('mt-cell', {
    attrs: {
      "title": _vm.model.caption,
      "required": _vm.param.required,
      "disabledcolor": !!_vm.param.disabled,
      "titlewidth": _vm.titlewidth,
      "value-align": _vm.textalign
    }
  }, [_c('mt-switch', {
    attrs: {
      "disabled": !!_vm.param.disabled
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.currentValue),
      callback: function($$v) {
        _vm.currentValue = $$v
      },
      expression: "currentValue"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.param.readonly) ? _c('mt-cell', {
    attrs: {
      "title": _vm.model.caption,
      "readonly": _vm.param.readonly,
      "titlewidth": _vm.titlewidth,
      "value-align": _vm.textalign
    }
  }, [_c('div', {
    staticClass: "em-select-value mt-color-grey-lv3"
  }, [
    [_vm._v(_vm._s(_vm.displayValue))]
  ], 2)]) : _vm._e()], 1)
},staticRenderFns: []}


// WEBPACK FOOTER //
// ./src/components/emapm-form/emapComponents/emSwitcher.vue